const clients = [
  { name: 'BrandCo', abbr: 'BC' },
  { name: 'Stanbic IBTC Bank', abbr: 'SB' },
  { name: 'Enstore', abbr: 'EN' },
  { name: 'Tripple A OZ Solutions', abbr: 'TA' },
  { name: 'Nigeria Distribution', abbr: 'ND' },
  { name: 'Hudson Band', abbr: 'HB' },
  { name: 'The Body Shop', abbr: 'BS' },
  { name: 'Xanda Technologies', abbr: 'XT' },
  { name: 'Madison & Park', abbr: 'MP' },
  { name: 'RedCloud', abbr: 'RC' },
  { name: 'Dukan', abbr: 'DK' },
  { name: 'Tennece', abbr: 'TN' },
];

const accentColors = [
  'rgba(232,25,44,0.7)',
  'rgba(255,200,0,0.7)',
  'rgba(255,120,30,0.7)',
  'rgba(60,200,120,0.7)',
  'rgba(232,25,44,0.5)',
  'rgba(200,200,255,0.6)',
  'rgba(255,180,0,0.7)',
  'rgba(30,200,200,0.7)',
];

const doubled = [...clients, ...clients];

export default function MarqueeSection() {
  return (
    <div
      className="relative py-10 overflow-hidden"
      style={{
        background: 'linear-gradient(to bottom, #07070f 0%, #0a0a16 50%, #07070f 100%)',
        borderTop: '1px solid rgba(232,25,44,0.15)',
        borderBottom: '1px solid rgba(232,25,44,0.15)',
      }}
    >
      {/* Heading */}
      <div className="mb-7 text-center relative z-10">
        <span className="inline-flex items-center gap-2">
          <span className="block w-8 h-px bg-thl-red/60" />
          <span className="text-white/50 text-xs uppercase tracking-[0.25em] font-semibold">
            Trusted by Leaders Across Industries
          </span>
          <span className="block w-8 h-px bg-thl-red/60" />
        </span>
      </div>

      {/* Edge fade masks */}
      <div
        className="absolute inset-y-0 left-0 w-28 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to right, #07070f 0%, transparent 100%)' }}
      />
      <div
        className="absolute inset-y-0 right-0 w-28 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to left, #07070f 0%, transparent 100%)' }}
      />

      {/* Track */}
      <div className="overflow-hidden">
        <div className="marquee-track">
          {doubled.map((client, i) => {
            const color = accentColors[i % accentColors.length];
            return (
              <div key={i} className="flex items-center shrink-0 px-3">
                {/* Brand badge */}
                <div
                  className="flex items-center gap-3 px-5 py-2.5 rounded-full whitespace-nowrap cursor-default select-none"
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: `1px solid rgba(255,255,255,0.09)`,
                    backdropFilter: 'blur(4px)',
                  }}
                >
                  {/* Colored monogram circle */}
                  <span
                    className="flex items-center justify-center rounded-full text-[10px] font-black leading-none"
                    style={{
                      width: 28,
                      height: 28,
                      background: `${color.replace('0.7', '0.15').replace('0.5', '0.15').replace('0.6', '0.15')}`,
                      border: `1px solid ${color}`,
                      color,
                      flexShrink: 0,
                    }}
                  >
                    {client.abbr}
                  </span>
                  <span className="text-white/80 text-sm font-semibold tracking-wide">
                    {client.name}
                  </span>
                </div>
                {/* Separator dot */}
                <span
                  className="mx-3 rounded-full shrink-0"
                  style={{ width: 4, height: 4, background: 'rgba(232,25,44,0.4)' }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
